import React from 'react';
import ProductList from './ProductList';
import { useLocation } from 'react-router-dom';

const ProductSearch = ({ route, navigate }) => {
    const location = useLocation();

    return (
        <div className="p-4 bg-[#fefaed]">
            <section class="py-10 text-center">
                <div class="mb-6">
                    <h3 class="font-bold" style={{ fontFamily: 'avenir_next_lt_pro_heavy_condensed_italic', fontSize: 48 }}>
                        <span class="text-[#ffd988] drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">Search</span>
                        &nbsp;
                        <span class="text-[#ff8e35] drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">Page</span>
                    </h3>
                </div>

                {location?.state?.prod ?
                    <section class="py-0 text-center">
                        <div class="max-w-full px-4 py-10 sm:px-6 lg:px-0 lg:py-0 mx-auto">
                            <ProductList products={location.state.prod} />
                        </div>
                    </section>
                    :
                    <div></div>
                }

                <div class="flex flex-col p-5 lg:px-24 lg:py-10" style={{ fontFamily: 'MuseoSansRounded500', fontSize: 14 }}>
                    {location?.state?.artikel.filter((items) => items.category_id == 1 || items.category_id == 2).map((item, index) => (
                    <div class="bg-white-100 p-5 mb-10 text-left">
                        <h1 class="font-bold text-2xl mb-2">{item.name}</h1>
                        <p class="my-3">{item.intro}</p>
                        <a href={`/detailblog/${item.id}`} class="text-white font-semibold bg-blue-600 hover:bg-blue-800 p-2 my-1 rounded">Read More...</a>
                    </div>
                    ))}
                </div>
            </section>
        </div>
    );
}

export default ProductSearch;
